/** Placeholder shown for any count the list endpoint hasn't sent for a row. */
export const EMPTY_CELL = "-";

/**
 * `completionRate` / `errorRate` arrive on the journey rows as fractions (0.739), so they
 * are scaled here. The design shows one decimal ("73.9%", "2.0%") except at exactly zero,
 * which reads "0%".
 */
export const formatRatePercent = (rate?: number | null): string => {
  if (typeof rate !== "number" || Number.isNaN(rate)) return EMPTY_CELL;
  if (rate === 0) return "0%";
  return `${(rate * 100).toFixed(1)}%`;
};

/**
 * Bar width for the Completion column, clamped so a stray >1 rate can't overflow the track.
 * Rounded to one decimal because the raw product carries float noise (0.829 * 100 =
 * 82.89999999999999) that would otherwise land in `aria-valuenow` and the inline width.
 */
export const getCompletionBarWidth = (rate?: number | null): number => {
  if (typeof rate !== "number" || Number.isNaN(rate)) return 0;
  const clamped = Math.min(Math.max(rate * 100, 0), 100);
  return Math.round(clamped * 10) / 10;
};

/** Plain counts render as-is; a missing count renders the placeholder, never "0". */
export const formatCount = (count?: number | null): string =>
  typeof count === "number" && !Number.isNaN(count)
    ? count.toLocaleString()
    : EMPTY_CELL;
